const CARRIER_SUPPORT_CONTACTS = {
    "j-link": {phone: "1-800-000-0001", email: "support@j-link.com"},
    csa: {phone: "1-800-000-0002", email: "support@csaltl.com"},
    purolator: {phone: "1-800-000-0003", email: "support@purolator.com"},
    dayandross: {phone: "1-800-000-0004", email: "support@dayandross.com"},
    vitran: {phone: "1-800-000-0005", email: "support@vitran.com"},
    tforce: {phone: "1-800-000-0006", email: "support@tforce.com"},
    bison: {phone: "1-800-000-0007", email: "support@bisontransport.com"},
    kindersley: {phone: "1-800-000-0008", email: "support@kindersleytransport.com"},
    cvc: {phone: "1-800-000-0009", email: "support@cvcltd.com"},
    "tforce-worldwide": {phone: "1-800-000-0010", email: "support@tforceworldwide.com"},
    medallion: {phone: "1-800-000-0011", email: "support@medallion.com"},
};

const DEFAULT_CARRIER_SUPPORT_CONTACT = {phone: "1-888-000-0000", email: "op@uucargo.ca"};

export const ROUTE_PROGRESS_BY_STATUS = {
    "Ready for Shipping": 4,
    "In Transit": 50,
    "Out for Delivery": 85,
    Delivered: 100,
    Exception: 40,
    "Not Found": 4,
    "No Tracking Yet": 4,
};

export const getCarrierSupportContact = (carrierName) => {
    if (!carrierName || carrierName === "N/A") return null;

    const carrierKey = Object.keys(CARRIER_SUPPORT_CONTACTS).find(
        (serviceName) => serviceName.toUpperCase() === carrierName.toUpperCase(),
    );
    return carrierKey ? CARRIER_SUPPORT_CONTACTS[carrierKey] : DEFAULT_CARRIER_SUPPORT_CONTACT;
};

export const normalizeTrackingNumber = (value) => value.replace(/\s+/g, "").toUpperCase();
